import { UserWorkLogsReport } from '../../../types/apiDomain';
import requestReport, { ReportParams } from './requestReport';

export interface RequestWorkLogsParams extends Omit<ReportParams, 'employees'> {
    user?: string;
}

export default (params: RequestWorkLogsParams) => requestReport<UserWorkLogsReport>(params, `/api/report/worklogs`);
